import React from "react";
import { Outlet } from "react-router-dom";
import TeacherSidebar from "../components/TeacherSidebar";
import SchoolHeader from "../components/SchoolHeader";
import Footer from "../components/Footer";

export default function TeacherLayout() {
  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      <TeacherSidebar />
      <div className="flex-grow-1">
        <SchoolHeader />
        <Outlet />
        <Footer />
      </div>
    </div>
  );
}

